import { render, staticRenderFns } from "./CategoryItemContent.vue?vue&type=template&id=718e09f4&scoped=true&"
import script from "./CategoryItemContent.vue?vue&type=script&lang=js&"
export * from "./CategoryItemContent.vue?vue&type=script&lang=js&"
import style0 from "./CategoryItemContent.vue?vue&type=style&index=0&id=718e09f4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718e09f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('718e09f4')) {
      api.createRecord('718e09f4', component.options)
    } else {
      api.reload('718e09f4', component.options)
    }
    module.hot.accept("./CategoryItemContent.vue?vue&type=template&id=718e09f4&scoped=true&", function () {
      api.rerender('718e09f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/parts/target/CategoryItemContent.vue"
export default component.exports